var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Customers","page-icon":"mdi-account-multiple","collection-name":"customer","items-per-page":20,"add-dialog-title":"Add Customer","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }